import { Box, VStack,  Text, theme } from '@bpba/ui-components';
import { IconArrow } from '../styles/AdhesionClientesStyles';
import Simbolito from '../../assets/micrositios/bullet.svg';
import { SeccionVideoTutorialAdhesion } from '../../components/SeccionVideoTutorialAdhesion';
import { useState } from 'react';

export const TutorialAdhesion = () => {
  const accordionData = [
    {
      title: <>¿Cuáles son los requisitos para descargarme Cuenta DNI Comercios?</>,
      content: (
        <>
Para poder descargarte Cuenta DNI Comercios debés ser persona humana mayor de 18 años, con DNI argentino, inscripto en ARCA (ex AFIP) como monotributista o responsable inscripto con domicilio fiscal o locales/establecimientos registrados en CABA o Provincia de Buenos Aires.        </>
      ),
      key: 1,
    },
    {
      title: <>¿Cómo me doy de alta si quiero cobrar desde el celular?</>,
      content: (
        <>

          Descargá Cuenta DNI Comercios desde el App Store para teléfonos Iphone y desde Google Play Store para teléfonos Android
          <br />
          <br />
          Abrí la app, presioná en Registrarme, aceptá los términos y condiciones e ingresá tu CUIT. Si no tenés una cuenta en el Banco, vamos a abrirla de forma 100% digital.
          <br />
          <br />
          Primero debemos validar tu identidad, vamos a pedirte unas fotos de tu DNI y de tu cara. ¡Buscá un lugar con buena luz y seguí las instrucciones!
          <br />
          <br />
          Si pudimos confirmar tu identidad, vamos a solicitarte tus datos de contacto y tu domicilio legal actual.
          <br />
          <br />
          Luego vas a poder elegir en qué sucursal del Banco abrir tu cuenta, si querés o no una tarjeta de débito y vas a crear tu contraseña. Solo seguí las instrucciones y recordá que la misma debe:
          <br />
          <br />
          <Box style={{ marginLeft: "2rem" }}> a) Tener un mínimo de 8 caractéres de largo.</Box>
          <Box style={{ marginLeft: "2rem" }}>b)	Tener una mayúscula, una minúscula y un número.</Box>
          <Box style={{ marginLeft: "2rem" }}>c)	 No superar los 6 números o letras consecutivos</Box>
          <br />
          <label>Si la contraseña está bien confeccionada, vamos a enviarte un código de acceso al correo electrónico que dejaste registrado para que actives tu cuenta. Si no lo recibiste, revisá la carpeta de Correo no deseado o presioná “Reenviar código”.</label>

          Por último, creá tu comercio y punto de venta principal ingresando los datos solicitados, seleccioná en que cuenta queres recibir tus cobros y ¡listo!
          <br />
          <br />
          Si no eras cliente del Banco, lo único que falta es que nos envíes tu comprobante de inscripción a Ingresos Brutos, puede ser un documento o una foto, para que la revisemos y activemos tu comercio sin límite de ventas.
          <br />
          <br />
          Aunque podés hacerlo más tarde, recordá que hasta que no la aprobemos vas a poder vender hasta $12.500 y luego tu app se bloqueará.
          <br />
          <br />
          Recordá: si abriste la cuenta por la app, vas a tener que esperar 48hs hábiles para que esté habilitada y puedas empezar a vender.
          <br />
          <br />
          <label>Si te quedaron dudas, comunicarte con la línea de atención de Cuenta DNI Comercios: <b><a href='tel:08106662364' style={{ textDecoration: "none", color: "secondary.1" }}> Cuenta DNI Comercios: 0810 666 2364.</a></b>.</label>
          <br />

        </>
      ),
      key: 2,
    },
    {
      title: <>¿Es seguro?</>,
      content: (
        <>
          Cuenta DNI Comercios es una aplicación robusta en seguridad, la identidad del cliente es validada por el Registro Nacional de Las Personas (RENAPER) de manera online, mediante reconocimiento facial, asegurándonos este modo de que coincida con el DNI escaneado.
        </>
      ),
      key: 3,
    },
    {
      title: <>¿Qué pasa si me olvido la clave? ¿Cómo desbloqueo la clave de acceso de la aplicación?</>,
      content: (
        <>
          Presionando "Olvidé mi contraseña/ correo electrónico", realizaremos una validación de tu identidad mediante reconocimiento facial y luego te enviaremos un código de validación a tu correo electrónico con el cual podrás generar una nueva contraseña.
        </>
      ),
      key: 4,
    },
    {
      title: <>Cambié mi equipo móvil, ¿qué debo hacer?</>,
      content: <>En caso de cambio de celular, tenés que volver a descargar la aplicación e ingresar con tu mail y contraseña.</>,
      key: 5,
    },
    {
      title: <>¿Cuál es el teléfono de Cuenta DNI Comercios?</>,
      content: <label>Comunicate con nosotros al <a href='tel:08106662364' style={{ textDecoration: "none", color: theme.colors.secondary[1], fontWeight: "bold" }}>0810-666-2364.</a>.</label>,
      key: 6,
    },
  ];

  return (
    <>

      <VStack
        height={['auto']}
        width={['100%']}
        flex={['flex']}
        justifyContent={['space-between']}
        marginTop={['2rem']}
        flexDirection={['column', 'column', 'row', 'row']}
        tabIndex={0}
      >
        <VStack
          width={['100%', '100%', '32.5%', '32.5%']}
          height={['100%']}
          backgroundColor={theme.colors.white}
          borderRadius={['3px 20px']}
          paddingX={['7%', '7%', '2%', '2%']}
          marginBottom={['1rem']}
        >
          <Box width={'100%'} height={'1.5rem'} marginLeft={['-8.1%', '-8.1%', '-7%', '-7%']} marginBottom={'0.5rem'}>
            <Box
              width={'5rem'}
              backgroundColor={theme.colors.primary[0]}
              borderRadius={'3px 3px 10px 3px'}
              paddingLeft={'0.7rem'}
              paddingTop={'0.2rem'}
              style={{ fontSize: '13px', color: theme.colors.white }}
              tabIndex={0}
            >
              Nuevo!{' '}
            </Box>
          </Box>
          <Box height={['4rem', '2rem', '5rem', '4rem']}>
            <Text fontSize={['22px']} lineHeight={['27px']} fontWeight={'bold'} color={theme.colors.secondary[1]} style={{ margin: '0' }} tabIndex={0}>
              ¡Cobrá a distancia con un link de pago!
            </Text>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']} tabIndex={0}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                1
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Presioná “Cobrar” y seleccioná “Link de pago”.
            </Box>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}

            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                2
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Ingresá el importe y luego presioná “Compartir link de pago”.
            </Box>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                3
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Tu cliente tiene hasta 72 h para abrir el link y pagarte.
            </Box>
          </Box>
        </VStack>
        <VStack
          width={['100%', '100%', '32.5%', '32.5%']}
          height={['100%']}
          backgroundColor={theme.colors.white}
          borderRadius={['3px 20px']}
          paddingX={['7%', '7%', '2%', '2%']}
          marginBottom={['1rem']}
        >
          <Box width={'100%'} height={'1.5rem'} marginBottom={'0.5rem'} />
          <Box height={['4rem', '2rem', '5rem', '4rem']}>
            <Text fontSize={['22px']} lineHeight={['27px']} fontWeight={'bold'} color={theme.colors.secondary[1]} style={{ margin: '0' }} tabIndex={0}>
              Generá un QR y cobrá desde el celular.
            </Text>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                1
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Presioná “Cobrar” y seleccioná “Generá tu QR”.
            </Box>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                2
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Ingresá el importe y generá el QR. El código dura 10 minutos.
            </Box>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                3
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              ¡El cliente o la clienta escanea el código con su billetera digital y listo!
            </Box>
          </Box>
        </VStack>
        <VStack
          width={['100%', '100%', '32.5%', '32.5%']}
          height={['100%']}
          backgroundColor={theme.colors.white}
          borderRadius={['3px 20px']}
          paddingX={['7%', '7%', '2%', '2%']}
          marginBottom={['1rem']}
        >
          <Box width={'100%'} height={'1.5rem'} marginBottom={'0.5rem'} />
          <Box height={['4rem', '2rem', '5rem', '4rem']}>
            <Text fontSize={['22px']} lineHeight={['27px']} fontWeight={'bold'} color={theme.colors.secondary[1]} style={{ margin: '0' }} tabIndex={0}>
              Imprimí un QR para dejar visible en tu local.
            </Text>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                1
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Presioná “Cobrar” y seleccioná “Imprimir tu QR”.
            </Box>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                2
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Presioná “Compartir” para enviarlo e imprimirlo.
            </Box>
          </Box>
          <Box height={['4rem', '4rem', '6rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box
              display={'flex'}
              justifyContent={'center'}
              width={['auto', '10%', '20%', '20%']}
              height={'100%'}
              marginRight={'1rem'}
              alignItems={'center'}
            >
              <Box
                width={'50px'}
                height={'50px'}
                padding={'10px'}
                border={'5px solid #25b4bd'}
                borderRadius={'50%'}
                color={theme.colors.primary[0]}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ fontSize: '30px', fontWeight: 'bolder' }}
                tabIndex={0}
              >
                3
              </Box>
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              ¡Ponelo visible en tu local para cobrar tus ventas! No tiene vencimiento.
            </Box>
          </Box>
        </VStack>
      </VStack>
      <Box width={['100%']} flex={['flex']} flexDirection={['column']} justifyContent={['center']} alignItems={['center']}>
        <Box
          width={'44%'}
          height={'5px'}
          marginY={'4rem'}
          border={'none'}
          borderRadius={'2rem'}
          backgroundImage={'linear-gradient(to right, #279d2e, #00a563, #00aec3)'}
        />
      </Box>

      <VStack
        height={['auto']}
        flex={['flex']}
        justifyContent={['space-between']}
        marginY={'1rem'}
        flexDirection={['column', 'column', 'row', 'row']}
      >
        <VStack width={['100%', '100%', '50%', '50%']} padding={['3%']}>
          <img src="/CDN/Get/CuentaDniAppcomercios" alt='imagen cuenta dni comercios' />
        </VStack>
        <VStack width={['100%', '100%', '50%', '50%']} paddingX={['4%', '4%', '0', '0']} paddingTop={['2rem', '2rem', '4rem', '4rem']} tabIndex={0}>
          <Box display={'flex'} justifyContent={'center'}>
            <Text fontSize={['28px']} lineHeight={['37px']} color={theme.colors.secondary[1]} tabIndex={0}>
              ¡Mirá crecer tus ventas!
            </Text>
          </Box>
          <Box height={['3rem', '3rem', '4rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box display={'flex'} justifyContent={'center'} width={'30px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
              <img src={Simbolito} alt={''} />
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Controlá el saldo y tus últimas ventas, estés donde estés.
            </Box>
          </Box>
          <Box height={['3rem', '3rem', '4rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box display={'flex'} justifyContent={'center'} width={'30px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
              <img src={Simbolito} alt={''} />
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              Descargá y compartí los comprobantes de pago.
            </Box>
          </Box>
          <Box height={['3rem', '3rem', '4rem', '4rem']} display={['flex']} flexDirection={['row']} marginY={['0.5rem']}>
            <Box display={'flex'} justifyContent={'center'} width={'30px'} height={'100%'} marginRight={'1rem'} alignItems={'center'}>
              <img src={Simbolito} alt={''} />
            </Box>
            <Box style={{ fontSize: '16px', lineHeight: '21px' }} alignItems={'center'} tabIndex={0}>
              ¡Podés ver las ventas de los últimos tres meses, para llevar un mayor control!
            </Box>
          </Box>
        </VStack>
      </VStack>
      <Box width={['100%']} height={['auto']} display={['flex']} justifyContent={['center']} marginBottom={['0','0','2rem','2rem']} tabIndex={0}>

        <Text fontSize={['28px']} lineHeight={['37px']} color={theme.colors.secondary[1]} tabIndex={0}>
        ¿Te quedaron dudas? Mirá estos tutoriales:
      </Text>
      </Box>
      <SeccionVideoTutorialAdhesion title='¿Cómo cobro con QR?' url='UhBTx0TAh44' />
      <SeccionVideoTutorialAdhesion title='¿Cómo cobro con link de pago?' url='S1t2UFA_Yes' />
      <SeccionVideoTutorialAdhesion title='¿Cómo veo movimientos?' url='msLC9g-lzZc' />


      <Box width={['100%']} height={['auto']} display={['flex']} justifyContent={['center']} marginBottom={['2rem']} tabIndex={0}>
        <Text fontSize={['28px']} lineHeight={['37px']} color={theme.colors.secondary[1]} tabIndex={0}>
          Preguntas Frecuentes
        </Text>
      </Box>
      <div className="accordion" style={{ marginBottom: "4rem" }} tabIndex={0}>
        {accordionData.map(({ title, content, key }) => (
          <Accordion title={title} content={content} key={key} aria-label={content} />
        ))}
      </div>
    </>
  );
};

type Props = {
  title: React.ReactElement;
  content: React.ReactElement;
};

const Accordion: React.FC<Props> = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <Box width={'100%'} height={'auto'} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
      <Box
        width={['80%', '80%', '60%', '60%']}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        color={theme.colors.secondary[1]}
        onClick={() => setIsActive(!isActive)}
        tabIndex={0}
      >
        <div style={{ width: '90%', fontSize: '20px', lineHeight: '25px' }}>{title}</div> <IconArrow />
      </Box>
      {isActive && (
        <Box
          width={['80%', '80%', '60%', '60%']}
          height={'auto'}
          marginY={'2rem'}
          display={'flex'}
          flexDirection={'column'}
          style={{ fontSize: '16px', lineHeight: '20px' }}
          tabIndex={0}
        >
          {content}
        </Box>
      )}
      <Box width={['80%', '80%', '60%', '60%']} height={'0.5px'} backgroundColor={theme.colors.secondary[1]} marginBottom={'2rem'} />
    </Box>
  );
};
